import { AirFleetCard } from './AircraftCard';

import type { AircraftCardItem } from '#entities';

export const AircraftCardAdapter = ({
  data,
  renderInsideWidget,
  onClickId,
  width = '100%',
}: {
  data: AircraftCardItem;
  width: number | string;
  renderInsideWidget: boolean;
  onClickId: (id: number) => void;
}) => (
  <AirFleetCard
    {...data}
    renderInsideWidget={renderInsideWidget}
    onClick={() => onClickId(data.Id)}
    sx={{ width, maxWidth: '100%' }}
  />
);
